// extracted by mini-css-extract-plugin
export default {"content":"OffertaPage_content__ednoQ","text":"OffertaPage_text__RVGVZ"};